import request from './request.js';

const api = {
	login(data) {
		return request.post('/api/User/LoginByPwd', null, data)
	},
	LoginByCode(data) {
		return request.post('/api/User/LoginByCode', null, data)
	},
}

export default api